import React from 'react';
import { ScrollButton } from './components/ScrollButton';
import { Star } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/jaTHcTWPhVq6VRqXa8cYP3/Diseno_Sin_Titulo_-_1_-_Editado.png';
export function App() {
  const scrollToPricing = () => {
    const el = document.getElementById('comprar');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#0a0a0a] text-zinc-300 selection:bg-orange-500 selection:text-white pb-20" data-id="element-0">
      {/* HERO SECTION */}
      <header className="pt-16 pb-12 md:pt-24 md:pb-20 px-4 max-w-4xl mx-auto text-center" data-id="element-1">
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-white leading-[0.9] mb-6 uppercase tracking-tight" data-id="element-2">
          Cómo convertir ideas simples en{' '}
          <span className="text-orange-500" data-id="element-3">diseños que venden</span>… usando IA
        </h1>
        <p className="text-xl md:text-2xl text-zinc-400 font-medium mb-10 max-w-2xl mx-auto" data-id="element-4">
          (aunque no seas diseñador)
        </p>

        <div className="relative max-w-2xl mx-auto mb-12 cursor-pointer group" onClick={scrollToPricing} data-id="element-5">
          <div className="absolute inset-0 bg-orange-500/20 blur-3xl rounded-full group-hover:bg-orange-500/30 transition-all duration-500" data-id="element-6"></div>
          <img src={PRODUCT_IMAGE} alt="Prompt Wear" className="relative z-10 w-full h-auto transform group-hover:scale-105 transition-transform duration-500" data-id="element-7" />
        </div>

        <ScrollButton className="w-full md:w-auto" data-id="element-8">
          QUIERO PROMPT WEAR AHORA
        </ScrollButton>
      </header>

      {/* SALES LETTER BODY */}
      <main className="px-4 max-w-3xl mx-auto text-lg md:text-xl leading-relaxed space-y-6" data-id="element-9">
        <p data-id="element-10">
          Si hoy te sentás frente a una IA y no sabés qué escribir para generar
          un diseño que realmente se pueda vender…
        </p>
        <p className="font-bold text-white" data-id="element-11">no sos el único.</p>
        <p data-id="element-12">
          De hecho, ese es exactamente el punto donde se queda atrapada la
          mayoría.
        </p>
        <p data-id="element-13">
          Tienen ganas. Tienen herramientas. Tienen acceso a inteligencia
          artificial. Tienen la sensación de que hay una oportunidad enorme
          enfrente.
        </p>
        <div className="bg-zinc-900 border-l-4 border-orange-500 p-6 my-10" data-id="element-14">
          <p className="text-xl md:text-2xl font-bold text-white italic m-0" data-id="element-15">
            Entonces la pregunta aparece sola:
            <br data-id="element-16" />
            ¿Por qué ellos sí pueden sacar resultados… y yo sigo perdiendo
            tiempo?
          </p>
        </div>

        <p data-id="element-17">La mayoría responde mal esa pregunta.</p>
        <p data-id="element-18">
          Piensan que el problema es falta de talento. Piensan que no tienen
          "ojo" para el diseño. Piensan que necesitan más tutoriales, más
          inspiración, más cursos o más tiempo.
        </p>
        <p className="font-bold text-white text-2xl mt-8" data-id="element-19">
          Pero la verdad es otra.
        </p>
        <p data-id="element-20">
          El problema no es que no sepas diseñar.{' '}
          <span className="text-orange-500 font-bold" data-id="element-21">
            El problema es que no tenés un sistema.
          </span>
        </p>
        <p data-id="element-22">Porque cuando usás la IA sin estructura, improvisás.</p>
        <p data-id="element-23">
          Y en un mercado donde otros ya están operando con procesos claros,
          improvisar sale caro.
        </p>
        <p data-id="element-24">
          Sale caro en tiempo. Sale caro en energía. Sale caro en motivación. Y,
          sobre todo, sale caro en oportunidad.
        </p>
        <p data-id="element-25">
          Mientras vos seguís probando prompts al azar, otros ya están
          construyendo catálogos. Mientras vos dudás qué estilo usar, otros ya
          están testeando nichos. Mientras vos tratás de "inspirarte", otros ya
          tienen producción.
        </p>
        <p data-id="element-26">Eso no pasa porque sean genios.</p>
        <p data-id="element-27">Pasa porque entendieron algo que cambia todo:</p>

        <p className="text-2xl font-bold text-white text-center py-8" data-id="element-28">
          la IA no recompensa al que más prueba, sino al que mejor estructura lo
          que le pide.
        </p>

        <div className="flex justify-center py-8" data-id="element-29">
          <ScrollButton data-id="element-30">SÍ, QUIERO EL SISTEMA</ScrollButton>
        </div>

        <p data-id="element-31">Y cuando entendés eso, cambia la forma en la que trabajás.</p>
        <p data-id="element-32">
          Ya no te sentás a ver "qué sale". Ya no dependés del humor del día ni
          de una chispa de inspiración. Ya no arrancás desde cero cada vez.
        </p>
        <p data-id="element-33">Ahora tenés una base. Una dirección. Una forma clara de ejecutar.</p>
        <p className="font-bold text-white text-2xl mt-8" data-id="element-34">
          Eso es exactamente lo que hace Prompt Wear.
        </p>
        <p data-id="element-35">
          Prompt Wear no es un curso. No es teoría. No es una colección
          desordenada de ideas lindas.
        </p>
        <p className="font-bold text-white text-xl" data-id="element-36">
          Crear 10. 20. 40 diseños en una sesión.
        </p>
        <p data-id="element-37">
          Explorar un nicho completo. Armar un catálogo. Testear conceptos.
          Probar líneas estéticas. Construir volumen.
        </p>
        <p data-id="element-38">
          Porque cuando tenés volumen, tenés opciones. Y cuando tenés opciones,
          tenés más posibilidades de acertar.
        </p>
        <p data-id="element-39">
          Eso es lo que te permite pasar de mirar el mercado desde afuera… a
          empezar a participar en serio.
        </p>

        <div className="flex justify-center py-8" data-id="element-40">
          <ScrollButton data-id="element-41">QUIERO EMPEZAR A PRODUCIR</ScrollButton>
        </div>

        <p className="mt-8" data-id="element-42">Tal vez hoy estás en uno de estos escenarios:</p>
        <ul className="space-y-4 my-6 list-disc pl-6 text-zinc-400" data-id="element-43">
          <li data-id="element-44">
            <strong className="text-white" data-id="element-45">
              Querés lanzar una marca de ropa
            </strong>
            , pero no sabés cómo generar suficientes diseños con consistencia.
          </li>
          <li data-id="element-46">
            <strong className="text-white" data-id="element-47">O ya vendés algo</strong>, pero
            sentís que tus diseños no tienen fuerza comercial.
          </li>
          <li data-id="element-48">
            <strong className="text-white" data-id="element-49">O descubriste la IA</strong> y
            entendiste que hay una oportunidad enorme, pero todavía no
            encontraste la forma de convertirla en un sistema rentable.
          </li>
          <li data-id="element-50">
            <strong className="text-white" data-id="element-51">O sos freelancer</strong> y querés
            dejar de depender totalmente de clientes para empezar a producir
            activos propios.
          </li>
        </ul>

        <p data-id="element-52">En cualquiera de esos casos, el dolor de fondo es parecido:</p>
        <p className="font-bold text-white" data-id="element-53">
          querés avanzar, pero no tenés una forma clara de hacerlo sin perder
          horas.
        </p>
        <div className="bg-orange-500 text-black p-8 my-10 font-bold text-2xl text-center transform -skew-y-2" data-id="element-54">
          <div className="transform skew-y-2" data-id="element-55">
            Y ahí apareció la revelación:
            <br data-id="element-56" />
            el problema nunca fue la IA. El problema era cómo se la estaba
            usando.
          </div>
        </div>

        <p className="font-bold text-white text-xl" data-id="element-57">
          Y en vez de depender de inspiración, podés entrar en modo producción.
        </p>
        <p data-id="element-58">Eso abre posibilidades reales.</p>
        <p data-id="element-59">
          Podés crear un catálogo más rápido. Podés explorar nichos con menos
          fricción. Podés generar material para print-on-demand. Podés preparar
          ideas para serigrafía. Podés construir el universo visual de una marca
          con más velocidad.
        </p>
        <p data-id="element-60">
          Y, sobre todo, podés dejar de sentir que estás improvisando cada paso.
        </p>

        {/* TESTIMONIALS SECTION */}
        <div className="my-20" data-id="element-61">
          <h2 className="font-display text-4xl md:text-5xl text-center text-white mb-10" data-id="element-62">
            Lo que dicen los que ya no improvisan
          </h2>
          <div className="grid gap-6" data-id="element-63">
            {[{
            name: 'Martín L., 28 — Buenos Aires',
            text: 'Llevaba semanas probando prompts random y no sacaba nada vendible. Con Prompt Wear generé 30 diseños en una tarde. Ya subí 15 a mi tienda de Mercado Libre.'
          }, {
            name: 'Valentina M., 26 — Mendoza',
            text: 'No sabía nada de diseño. Literalmente nada. Copié los prompts, los pegué y me salieron diseños que mis amigos me pidieron comprar. Increíble.'
          }].map((testimonial, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 p-6 rounded-lg" data-id="element-64">
                <div className="flex text-orange-500 mb-3" data-id="element-65">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-66" />)}
                </div>
                <p className="text-zinc-300 italic mb-4" data-id="element-67">
                  "{testimonial.text}"
                </p>
                <p className="text-white font-bold text-sm uppercase tracking-wider" data-id="element-68">
                  {testimonial.name}
                </p>
              </div>)}
          </div>
        </div>

        <p className="font-bold text-orange-500 text-3xl mt-8" data-id="element-69">
          Necesitás un sistema.
        </p>
        <p data-id="element-70">
          Uno que te diga qué escribir. Uno que te ayude a generar con más
          claridad. Uno que te acerque a resultados más útiles, más limpios y
          más listos para convertir en producto.
        </p>
        <p className="font-bold text-white text-2xl mt-8" data-id="element-71">
          Eso es Prompt Wear.
        </p>
        <p className="font-display text-4xl text-orange-500 tracking-wide my-6" data-id="element-72">
          Copiás. Pegás. Generás. Desarrollás. Vendés.
        </p>
        <p data-id="element-73">
          Y una vez que entendés esa lógica, dejás de mirar la IA como una
          curiosidad…
        </p>
        <p data-id="element-74">y empezás a usarla como una ventaja.</p>

        {/* PRICING / CHECKOUT SECTION */}
        <div id="comprar" className="mt-20 border-4 border-zinc-800 bg-black p-8 md:p-12 rounded-2xl text-center relative overflow-hidden" data-id="element-75">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-orange-600 via-orange-400 to-orange-600" data-id="element-76"></div>

          <h2 className="font-display text-5xl md:text-6xl text-white mb-8 uppercase" data-id="element-77">
            Accedé a <span className="text-orange-500" data-id="element-78">Prompt Wear</span>
          </h2>

          <img src={PRODUCT_IMAGE} alt="Prompt Wear" className="w-full max-w-md mx-auto mb-8 hover:scale-105 transition-transform duration-300" data-id="element-79" />

          <div className="mb-8" data-id="element-80">
            <p className="text-zinc-500 text-2xl line-through font-bold mb-2" data-id="element-81">
              $49.990
            </p>
            <p className="text-6xl md:text-7xl font-display text-white tracking-tight" data-id="element-82">
              $19.990{' '}
              <span className="text-xl text-orange-500 tracking-normal font-sans font-bold align-top" data-id="element-83">
                ARS
              </span>
            </p>
          </div>

          <a href="https://checkout.promptwearr.shop/cart/44479124242567:1" className="inline-block w-full md:w-auto bg-orange-500 hover:bg-orange-600 text-white font-display text-3xl md:text-4xl tracking-wide py-6 px-12 rounded-sm transition-all transform hover:scale-105 shadow-[0_0_40px_rgba(249,115,22,0.4)] hover:shadow-[0_0_60px_rgba(249,115,22,0.6)]" data-id="element-84">
            QUIERO PROMPT WEAR AHORA
          </a>

          <p className="mt-6 text-zinc-500 text-sm flex items-center justify-center gap-2" data-id="element-85">
            Pago 100% seguro y acceso inmediato
          </p>
        </div>

        {/* FINAL CTA */}
        <div className="mt-20 text-center pb-20" data-id="element-86">
          <p className="text-xl mb-6" data-id="element-87">
            Si querés pasar de la frustración a la ejecución, de la
            improvisación al sistema y de las ideas sueltas a diseños con
            potencial real de venta…
          </p>
          <p className="font-bold text-white text-2xl mb-8" data-id="element-88">
            Prompt Wear es el siguiente paso.
          </p>
          <p className="text-zinc-400 mb-10" data-id="element-89">
            No para seguir aprendiendo "algún día". Para empezar a producir
            ahora.
          </p>
          <p className="font-display text-5xl text-orange-500 tracking-wide mb-12" data-id="element-90">
            Copiá. Pegá. Creá. Vendé.
          </p>
          <ScrollButton data-id="element-91">SÍ, QUIERO ACCEDER AHORA</ScrollButton>
        </div>
      </main>
    </div>;
}